// extracted by mini-css-extract-plugin
module.exports = {"test":"UI_test__x5scQ","confirmBody":"UI_confirmBody__iBE1G","account":"UI_account__pjJUF","s_head":"UI_s_head__SDCEn","s_col":"UI_s_col__OMv41"};